module.exports = __webpack_public_path__ + "img/secondary-1.98edc6fa.svg";